<template>
  <div class="navbar-wrap">
    <header id="header" class="navbar-shell" :class="{ 'is-mobile': mobileNar }">
      <div class="nav-inner">
        <template v-if="!mobileNar">
          <el-menu
            :default-active="activeMenuName"
            class="nav-menu"
            :ellipsis="false"
            router
            mode="horizontal"
            active-text-color="#0f766e"
            text-color="#334155">
            <div class="logo" @click="handleRoute('/')">
              <el-image class="logo-image" :src="logoCodeACSrc" fit="scale-down" lazy></el-image>
              <div class="logo-copy">
                <div class="logo-title">CodeAC</div>
                <div class="logo-subtitle">算法训练与评测平台</div>
              </div>
            </div>

            <el-menu-item
              v-for="item in navItems"
              :key="item.index"
              :index="item.index"
              class="nav-item">
              <el-icon v-if="item.icon">
                <component :is="item.icon" />
              </el-icon>
              <span>{{ item.label }}</span>
            </el-menu-item>

            <div class="flex-grow" />

            <template v-if="!isLogin">
              <div class="btn-menu">
                <el-button type="primary" class="nav-btn nav-btn-primary" round @click="handleBtnClick('Login')">登录</el-button>
                <el-button class="nav-btn nav-btn-ghost" round @click="handleBtnClick('Register')">注册</el-button>
              </div>
            </template>
            <template v-else>
              <el-badge :value="unreadNoticeCount" :hidden="!unreadNoticeCount" class="notice-badge">
                <el-dropdown trigger="click" @command="handleRoute">
                  <button class="notice-btn" type="button" aria-label="通知">
                    <el-icon><Bell /></el-icon>
                  </button>
                  <template #dropdown>
                    <el-dropdown-menu>
                      <el-dropdown-item class="notice-item" command="/message/mine">
                        <span>我的消息</span>
                        <el-badge class="mark" :value="mineNum" />
                      </el-dropdown-item>
                      <el-dropdown-item class="notice-item" command="/message/system">
                        <span>系统消息</span>
                        <el-badge class="mark" :value="sysNum" />
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </template>
                </el-dropdown>
              </el-badge>

              <el-dropdown
                class="drop-menu"
                @command="handleRoute"
                placement="bottom-end"
                trigger="click"
                popper-class="avatar-dropdown-popper">
                <span class="user-entry">
                  <el-avatar :src="userAvatar" class="user-avatar">{{ avatarFallback }}</el-avatar>
                  <span class="user-name">{{ displayUsername }}</span>
                  <el-icon class="user-caret"><ArrowDown /></el-icon>
                </span>
                <template #dropdown>
                  <el-dropdown-menu class="avatar-dropdown-menu">
                    <el-dropdown-item class="avatar-dropdown-item" command="/user">个人信息</el-dropdown-item>
                    <el-dropdown-item class="avatar-dropdown-item" command="/user/group">我的团队</el-dropdown-item>
                    <el-dropdown-item v-if="userIsSuperAdmin" class="avatar-dropdown-item" divided command="/admin">Admin</el-dropdown-item>
                    <el-dropdown-item class="avatar-dropdown-item avatar-dropdown-item-danger" divided command="/logout">退出</el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </template>
          </el-menu>
        </template>

        <template v-else>
          <div class="mobile-topbar">
            <button class="mobile-logo-btn" type="button" @click="handleRoute('/')">
              <el-image class="mobile-logo-image" :src="logoCodeACSrc" fit="contain" lazy></el-image>
              <span class="mobile-logo-text">CodeAC</span>
            </button>
            <div class="mobile-actions">
              <template v-if="isLogin">
                <el-badge :value="unreadNoticeCount" :hidden="!unreadNoticeCount" class="notice-badge mobile-notice">
                  <el-dropdown trigger="click" @command="handleRoute">
                    <button class="notice-btn" type="button" aria-label="通知">
                      <el-icon><Bell /></el-icon>
                    </button>
                    <template #dropdown>
                      <el-dropdown-menu>
                        <el-dropdown-item class="notice-item" command="/message/mine">
                          <span>我的消息</span>
                          <el-badge class="mark" :value="mineNum" />
                        </el-dropdown-item>
                        <el-dropdown-item class="notice-item" command="/message/system">
                          <span>系统消息</span>
                          <el-badge class="mark" :value="sysNum" />
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </el-badge>

                <el-dropdown
                  class="mobile-user-dropdown"
                  @command="handleRoute"
                  placement="bottom-end"
                  trigger="click"
                  popper-class="avatar-dropdown-popper">
                  <span class="mobile-user-entry">
                    <el-avatar :src="userAvatar" class="user-avatar">{{ avatarFallback }}</el-avatar>
                  </span>
                  <template #dropdown>
                    <el-dropdown-menu class="avatar-dropdown-menu">
                      <el-dropdown-item class="avatar-dropdown-item" command="/user">个人信息</el-dropdown-item>
                      <el-dropdown-item class="avatar-dropdown-item" command="/user/group">我的团队</el-dropdown-item>
                      <el-dropdown-item v-if="userIsSuperAdmin" class="avatar-dropdown-item" divided command="/admin">Admin</el-dropdown-item>
                      <el-dropdown-item class="avatar-dropdown-item avatar-dropdown-item-danger" divided command="/logout">退出</el-dropdown-item>
                    </el-dropdown-menu>
                  </template>
                </el-dropdown>
              </template>
              <template v-else>
                <el-button text class="mobile-auth-btn" @click="handleBtnClick('Login')">登录</el-button>
              </template>

              <button class="mobile-menu-btn" type="button" @click="mobileMenuVisible = true" aria-label="打开导航菜单">
                <el-icon><MenuIcon /></el-icon>
              </button>
            </div>
          </div>
        </template>
      </div>
    </header>

    <el-drawer
      v-model="mobileMenuVisible"
      direction="rtl"
      size="82%"
      :with-header="false"
      class="mobile-nav-drawer">
      <div class="mobile-drawer-content">
        <div class="mobile-drawer-head">
          <div class="mobile-drawer-brand">
            <el-image class="mobile-drawer-logo" :src="logoCodeACSrc" fit="contain" lazy></el-image>
            <div>
              <p class="mobile-drawer-title">CodeAC</p>
              <p class="mobile-drawer-subtitle">算法训练与评测平台</p>
            </div>
          </div>
        </div>

        <el-menu class="mobile-drawer-menu" :default-active="activeMenuName" @select="onMobileMenuSelect">
          <el-menu-item
            v-for="item in navItems"
            :key="'mobile-' + item.index"
            :index="item.index">
            <el-icon v-if="item.icon">
              <component :is="item.icon" />
            </el-icon>
            <span>{{ item.label }}</span>
          </el-menu-item>
        </el-menu>

        <div class="mobile-drawer-footer">
          <template v-if="!isLogin">
            <el-button type="primary" class="drawer-auth-btn" @click="openLoginFromDrawer">登录</el-button>
            <el-button class="drawer-auth-btn" @click="openRegisterFromDrawer">注册</el-button>
          </template>
          <template v-else>
            <el-button text class="drawer-link-btn" @click="handleDrawerAction('/user')">个人信息</el-button>
            <el-button text class="drawer-link-btn" @click="handleDrawerAction('/user/group')">我的团队</el-button>
            <el-button v-if="userIsSuperAdmin" text class="drawer-link-btn" @click="handleDrawerAction('/admin')">Admin</el-button>
            <el-button text class="drawer-link-btn danger" @click="handleDrawerAction('/logout')">退出登录</el-button>
          </template>
        </div>
      </div>
    </el-drawer>

    <el-dialog v-model="loginModal" width="420px" class="auth-modal-shell" :show-close="false" append-to-body>
      <div class="auth-modal auth-modal-login">
        <div class="auth-modal-hero">
          <p class="auth-modal-kicker">CODEAC ACCOUNT</p>
          <h3>登录 CodeAC</h3>
          <p>继续你的学习节奏，完成今天的训练目标。</p>
        </div>
        <div class="auth-modal-body">
          <el-form ref="loginFormRef" :model="loginForm" :rules="loginRules" class="auth-modal-form" @submit.prevent>
            <el-alert
              v-if="loginServerErrors.general"
              type="error"
              :closable="false"
              show-icon
              class="login-error-alert">
              {{ loginServerErrors.general }}
            </el-alert>
            <el-form-item prop="username" :error="loginServerErrors.username">
              <el-input
                v-model.trim="loginForm.username"
                class="auth-input"
                placeholder="用户名"
                clearable
                @input="clearLoginServerError('username')" />
            </el-form-item>
            <el-form-item prop="password" :error="loginServerErrors.password">
              <el-input
                v-model="loginForm.password"
                class="auth-input"
                type="password"
                show-password
                placeholder="密码"
                @input="clearLoginServerError('password')" />
            </el-form-item>
            <div class="demo-auto-login">
              <el-checkbox v-model="autoLogin" size="large">自动登录</el-checkbox>
              <a @click="handleBtnClick('ForgetPassword')">忘记密码</a>
            </div>
            <el-button class="auth-submit" type="primary" @click="handleLogin">登录</el-button>
          </el-form>
          <p class="auth-modal-switch">
            还没有账号？
            <a @click="handleBtnClick('Register')">立即注册</a>
          </p>
        </div>
      </div>
    </el-dialog>

    <el-dialog v-model="registerModal" width="460px" class="auth-modal-shell" :show-close="false" append-to-body>
      <div class="auth-modal auth-modal-register">
        <div class="auth-modal-hero">
          <p class="auth-modal-kicker">CODEAC ACCOUNT</p>
          <h3>创建新账号</h3>
          <p>加入 CodeAC，开始系统化算法训练。</p>
        </div>
        <div class="auth-modal-body">
          <el-form ref="registerFormRef" :model="registerForm" :rules="registerRules" class="auth-modal-form" @submit.prevent>
            <el-form-item prop="username">
              <el-input v-model.trim="registerForm.username" maxlength="10" show-word-limit class="auth-input" placeholder="用户名" clearable />
            </el-form-item>
            <el-form-item prop="mail">
              <el-input v-model.trim="registerForm.mail" class="auth-input" placeholder="邮箱" clearable />
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                v-model="registerForm.password"
                class="register-password auth-input"
                type="password"
                show-password
                placeholder="至少6位密码，区分大小写" />
              <div class="demo-register-tip" style="margin-top: 8px;">
                <div class="demo-register-tip-title" :class="passwordTip.class">
                  强度：{{ passwordTip.strong }}
                </div>
                <el-progress
                  :percentage="passwordTip.percent"
                  :stroke-width="6"
                  :color="passwordTip.color"
                  :show-text="false" />
                <div class="demo-register-tip-desc">
                  请至少输入 6 个字符。请不要使用容易被猜到的密码。
                </div>
              </div>
            </el-form-item>
            <el-form-item prop="passwordConfirm">
              <el-input v-model="registerForm.passwordConfirm" class="auth-input" type="password" show-password placeholder="确认密码" />
            </el-form-item>
            <div class="demo-auto-login">
              <el-checkbox v-model="autoLogin" size="large">自动登录</el-checkbox>
              <a @click="handleBtnClick('Login')">已有账号，请登录</a>
            </div>
            <el-button class="auth-submit" type="primary" @click="handleRegister">注册</el-button>
          </el-form>
        </div>
      </div>
    </el-dialog>

    <el-dialog v-model="forgetPasswdModal" width="420px" class="auth-modal-shell" :show-close="false" append-to-body>
      <div class="auth-modal auth-modal-forget">
        <div class="auth-modal-hero">
          <p class="auth-modal-kicker">PASSWORD RESET</p>
          <h3>重置密码</h3>
          <p>输入绑定邮箱，我们将发送重置链接。</p>
        </div>
        <div class="auth-modal-body">
          <el-form ref="forgetFormRef" :model="forgetForm" :rules="forgetRules" class="auth-modal-form" @submit.prevent>
            <el-alert type="warning" :closable="false" v-show="forgetEmailValid === 0" show-icon>请输入绑定的邮箱地址:</el-alert>
            <el-alert type="error" :closable="false" v-show="forgetEmailValid === 1" show-icon>邮箱错误，请检查邮箱地址！</el-alert>
            <el-alert type="success" :closable="false" v-show="forgetEmailValid === 2" show-icon>邮件已发送！</el-alert>
            <el-form-item prop="mail" style="margin-top: 12px;">
              <el-input v-model.trim="forgetForm.mail" class="auth-input" placeholder="邮箱" clearable />
            </el-form-item>
            <div class="demo-auto-login forget-links">
              <a @click="handleBtnClick('Login')">登录</a>
              <a @click="handleBtnClick('Register')">注册</a>
            </div>
            <el-button class="auth-submit" type="primary" @click="handleForgetPassword">提交</el-button>
          </el-form>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { ElAlert, ElNotification } from 'element-plus';
import {
    HomeFilled,
    List,
    Collection,
    Histogram,
    Reading,
    ChatDotRound,
    Monitor,
    Calendar,
    Bell,
    ArrowDown,
    Menu as MenuIcon,
} from '@element-plus/icons-vue';
import qs from 'qs';
import { avatarInitial, resolveAvatar } from '@/utils/avatar';
import 'element-plus/es/components/alert/style/css';

export default {
    name: "NavBar",
    components: {
        ElAlert,
        HomeFilled,
        List,
        Collection,
        Histogram,
        Reading,
        ChatDotRound,
        Monitor,
        Calendar,
        Bell,
        ArrowDown,
        MenuIcon,
    },
    data() {
        const validatePasswordConfirm = (rule, value, callback) => {
            if (value !== this.registerForm.password) {
                callback(new Error('两次输入的密码不匹配！'));
            } else {
                callback();
            }
        };
        const validateMail = (rule, value, callback) => {
            const emailReg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!value) {
                callback(new Error('邮箱不能为空！'));
                return;
            }
            if (!emailReg.test(value)) {
                callback(new Error('邮箱格式错误！'));
                return;
            }
            callback();
        };
        return {
            mobileNar: false,
            mobileMenuVisible: false,
            logoCodeACSrc: require('@/assets/logo_codeac.png'),
            navItems: [
                { index: '/', label: '首页', icon: HomeFilled },
                { index: '/problem', label: '题目', icon: List },
                { index: '/activity', label: '活动', icon: Collection },
                { index: '/training', label: '题单', icon: Histogram },
                { index: '/knowledge', label: '知识分享', icon: Reading },
                { index: '/discussion', label: '问答区', icon: ChatDotRound },
                { index: '/ide', label: '云编辑器', icon: Monitor },
                { index: '/schedule', label: '课程表', icon: Calendar },
            ],
            autoLogin: true,
            loginModal: false,
            registerModal: false,
            forgetPasswdModal: false,
            forgetEmailValid: 0,
            loginForm: {
                username: '',
                password: '',
            },
            loginServerErrors: {
                username: '',
                password: '',
                general: '',
            },
            registerForm: {
                username: '',
                mail: '',
                password: '',
                passwordConfirm: '',
            },
            forgetForm: {
                mail: '',
            },
            loginRules: {
                username: [
                    { required: true, message: '用户名不能为空！', trigger: 'blur' },
                ],
                password: [
                    { required: true, message: '密码不能为空！', trigger: 'blur' },
                    { min: 6, message: '密码不能少于6位！', trigger: 'blur' },
                ],
            },
            registerRules: {
                username: [
                    { required: true, message: '用户名不能为空！', trigger: 'blur' },
                    { min: 2, max: 10, message: '用户名长度应为2-10位', trigger: 'blur' },
                ],
                mail: [{ validator: validateMail, trigger: 'blur' }],
                password: [
                    { required: true, message: '密码不能为空！', trigger: 'blur' },
                    { min: 6, message: '密码不能少于6位！', trigger: 'blur' },
                ],
                passwordConfirm: [
                    { required: true, message: '确认密码不能为空！', trigger: 'blur' },
                    { validator: validatePasswordConfirm, trigger: 'blur' },
                ],
            },
            forgetRules: {
                mail: [{ validator: validateMail, trigger: 'blur' }],
            },
            unreadNoticeCount: 0,
            commentNum: 0,
            replyNum: 0,
            likeNum: 0,
            sysNum: 0,
            mineNum: 0,
            resizeHandler: null,
        };
    },
    computed: {
        ...mapGetters(['userInfo', 'isLogin', 'token']),
        normalizedUserInfo() {
            if (!this.userInfo) return {};
            if (typeof this.userInfo === 'string') {
                try {
                    return JSON.parse(this.userInfo);
                } catch (e) {
                    return {};
                }
            }
            return this.userInfo;
        },
        displayUsername() {
            return this.normalizedUserInfo.username || '账号中心';
        },
        userAvatar() {
            return resolveAvatar(this.normalizedUserInfo.avatar, this.displayUsername);
        },
        userIsSuperAdmin() {
            return !!(
                this.normalizedUserInfo.isSuperAdmin ||
                this.normalizedUserInfo.admin_type === 'Super Admin' ||
                this.normalizedUserInfo.adminType === 'Super Admin'
            );
        },
        avatarFallback() {
            return avatarInitial(this.displayUsername);
        },
        activeMenuName() {
            const segment = this.$route.path.split('/')[1];
            if (segment === 'submission-detail') {
                return '/status';
            }
            if (segment === 'discussion-detail') {
                return '/discussion';
            }
            return '/' + segment;
        },
        passwordTip() {
            const passwordLen = this.registerForm.password ? this.registerForm.password.length : 0;
            let strong = '强';
            let className = 'strong';
            const percent = passwordLen > 10 ? 10 : passwordLen;
            let color = '#19be6b';

            if (passwordLen < 6) {
                strong = '太短';
                className = 'low';
                color = '#ed4014';
            } else if (passwordLen < 10) {
                strong = '中';
                className = 'medium';
                color = '#ff9900';
            }
            return {
                strong,
                class: 'demo-register-tip-' + className,
                percent: percent * 10,
                color
            };
        },
    },
    mounted() {
        this.init();
        this.pageWidth();
        this.resizeHandler = () => {
            this.pageWidth();
        };
        window.addEventListener('resize', this.resizeHandler);
    },
    beforeUnmount() {
        if (this.resizeHandler) {
            window.removeEventListener('resize', this.resizeHandler);
        }
    },
    watch: {
        '$route.path'() {
            this.mobileMenuVisible = false;
        }
    },
    methods: {
        init() {
            this.getUnreadMsgCount();
            this.getUserStatus();
        },
        pageWidth() {
            this.mobileNar = window.innerWidth < 992;
        },
        onMobileMenuSelect(index) {
            this.mobileMenuVisible = false;
            this.handleRoute(index);
        },
        handleDrawerAction(route) {
            this.mobileMenuVisible = false;
            this.handleRoute(route);
        },
        openLoginFromDrawer() {
            this.mobileMenuVisible = false;
            this.handleBtnClick('Login');
        },
        openRegisterFromDrawer() {
            this.mobileMenuVisible = false;
            this.handleBtnClick('Register');
        },
        notify(type, message, title = '系统通知') {
            ElNotification({
                title,
                message,
                type,
            });
        },
        clearLoginServerErrors() {
            this.loginServerErrors.username = '';
            this.loginServerErrors.password = '';
            this.loginServerErrors.general = '';
        },
        clearLoginServerError(field) {
            if (!field || !this.loginServerErrors[field]) {
                return;
            }
            this.loginServerErrors[field] = '';
            if (!this.loginServerErrors.username && !this.loginServerErrors.password) {
                this.loginServerErrors.general = '';
            }
        },
        resolveLoginError(payload) {
            const message = typeof payload?.message === 'string' ? payload.message.trim() : '';
            if (!message) {
                return {
                    type: 'general',
                    message: '登录失败，请检查账号和密码后重试',
                };
            }
            if (message.includes('用户名不存在')) {
                return {
                    type: 'username',
                    message: '用户名不存在，请确认后重试',
                };
            }
            if (message.includes('密码错误')) {
                return {
                    type: 'password',
                    message: '密码错误，请重新输入',
                };
            }
            if (message.includes('用户名') && message.includes('不能为空')) {
                return {
                    type: 'username',
                    message: '请输入用户名',
                };
            }
            if (message.includes('密码') && message.includes('不能为空')) {
                return {
                    type: 'password',
                    message: '请输入密码',
                };
            }
            if (message.includes('用户名') && message.includes('长度')) {
                return {
                    type: 'username',
                    message,
                };
            }
            if (message.includes('密码') && message.includes('长度')) {
                return {
                    type: 'password',
                    message,
                };
            }
            return {
                type: 'general',
                message,
            };
        },
        applyLoginError(errorInfo) {
            if (!errorInfo || !errorInfo.message) {
                return;
            }
            const { type, message } = errorInfo;
            if (type === 'username') {
                this.loginServerErrors.username = message;
                this.loginServerErrors.general = message;
            } else if (type === 'password') {
                this.loginServerErrors.password = message;
                this.loginServerErrors.general = message;
            } else {
                this.loginServerErrors.general = message;
            }
            this.notify('error', message, '登录失败');
        },
        async handleForgetPassword() {
            const valid = await this.$refs.forgetFormRef?.validate().catch(() => false);
            if (!valid) return;
            if (this.isLogin) {
                this.notify('warning', '您已经登录，无需重置密码！');
                return;
            }
            this.axios({
                url: '/api/auth/reset/email',
                method: 'post',
                data: qs.stringify({ email: this.forgetForm.mail })
            }).then((res) => {
                if (res.data.error_code === 0) {
                    this.forgetEmailValid = 2;
                    this.notify('success', '重置密码链接已在邮件发送，请查看！');
                } else {
                    this.forgetEmailValid = 1;
                    this.notify('error', '邮箱地址错误！');
                }
            }).catch((err) => {
                window.__CODEAC_LOGGER__?.debug(err);
            });
        },
        handleBtnClick(mode) {
            if (mode === "Login") {
                this.clearLoginServerErrors();
                this.loginModal = true;
                this.registerModal = false;
                this.forgetPasswdModal = false;
                this.forgetEmailValid = 0;
            } else if (mode === "ForgetPassword") {
                this.loginModal = false;
                this.registerModal = false;
                this.forgetPasswdModal = true;
                this.forgetEmailValid = 0;
            } else if (mode === "Register") {
                this.clearLoginServerErrors();
                this.loginModal = false;
                this.registerModal = true;
                this.forgetPasswdModal = false;
            }
        },
        getUserStatus() {
            this.axios({
                url: '/api/user/status',
                method: 'get',
            }).then((res) => {
                if (res.data.error_code === 40100 && this.isLogin) {
                    this.$store.dispatch('clearUserInfoAndToken');
                    this.notify('error', '登录失效，请重新登录！');
                }
            }).catch((err) => {
                window.__CODEAC_LOGGER__?.debug(err);
            });
        },
        getUnreadMsgCount() {
            if (!this.isLogin) {
                return;
            }
            this.axios({
                url: '/api/notice/unread',
                method: 'get',
            }).then((res) => {
                if (res.data.error_code === 0) {
                    this.unreadNoticeCount = res.data.data.unreadNoticeCount;
                    this.commentNum = res.data.data.commentNum;
                    this.replyNum = res.data.data.replyNum;
                    this.likeNum = res.data.data.likeNum;
                    this.sysNum = res.data.data.sysNum;
                    this.mineNum = res.data.data.mineNum;
                } else {
                    this.unreadNoticeCount = 0;
                }
            }).catch((err) => {
                window.__CODEAC_LOGGER__?.debug(err);
            });
        },
        async handleRegister() {
            const valid = await this.$refs.registerFormRef?.validate().catch(() => false);
            if (!valid) return;
            if (this.isLogin) {
                this.notify('warning', '您已经登录，无需注册！');
                return;
            }
            this.axios({
                url: '/api/auth/register',
                method: 'post',
                data: {
                    username: this.registerForm.username,
                    email: this.registerForm.mail,
                    password: this.registerForm.password
                }
            }).then((res) => {
                if (res.data.error_code === 0) {
                    this.notify('success', '注册成功', 'Success');
                    this.handleBtnClick('Login');
                    this.loginForm.username = this.registerForm.username;
                    this.loginForm.password = '';
                } else {
                    this.notify('error', res.data.message || '注册失败', 'Error');
                }
            }).catch((err) => {
                window.__CODEAC_LOGGER__?.debug(err);
            });
        },
        async handleLogin() {
            this.clearLoginServerErrors();
            const valid = await this.$refs.loginFormRef?.validate().catch(() => false);
            if (!valid) return;
            if (this.isLogin) {
                this.notify('warning', '您已经登录，请不要重复登录！');
                return;
            }
            this.axios({
                url: '/api/auth/login',
                method: 'post',
                data: {
                    username: this.loginForm.username,
                    password: this.loginForm.password
                }
            }).then((res) => {
                if (res.data.error_code === 0) {
                    const jwt = res.data.data.jwt;
                    this.$store.commit('changeUserToken', jwt);
                    this.$store.dispatch('setUserInfo', JSON.stringify(res.data.data.user));
                    location.reload();
                } else {
                    this.applyLoginError(this.resolveLoginError(res.data));
                }
            }).catch((err) => {
                const backendError = this.resolveLoginError(err?.response?.data);
                if (backendError.message !== '登录失败，请检查账号和密码后重试') {
                    this.applyLoginError(backendError);
                    return;
                }
                this.applyLoginError({
                    type: 'general',
                    message: err?.message || '网络异常，请稍后重试',
                });
            });
        },
        handleRoute(route) {
            this.mobileMenuVisible = false;
            if (route && route.split('/')[1] !== 'admin') {
                if (route === "/logout") {
                    this.axios({
                        url: '/api/auth/logout',
                        method: 'post',
                    }).then(() => {
                        this.$store.dispatch('clearUserInfoAndToken');
                        location.reload();
                    }).catch((err) => {
                        window.__CODEAC_LOGGER__?.debug(err);
                    });
                } else {
                    this.$router.push(route);
                }
            } else if (route) {
                window.open('/admin/');
            }
        },
    },
};
</script>

<style scoped lang="less">
.navbar-wrap {
    position: sticky;
    top: 0;
    z-index: 1000;
}

#header.navbar-shell {
    width: 100%;
    border-bottom: 1px solid rgba(15, 118, 110, 0.16);
    backdrop-filter: blur(14px);
    background:
      radial-gradient(circle at 10% 15%, rgba(20, 184, 166, 0.12), transparent 35%),
      radial-gradient(circle at 90% 0%, rgba(14, 165, 233, 0.12), transparent 30%),
      rgba(255, 255, 255, 0.86);
}

.nav-inner {
    max-width: 1520px;
    margin: 0 auto;
    padding: 6px 12px;
}

.nav-menu {
    border-bottom: none !important;
    background: transparent !important;
    min-height: 66px;
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 0 10px;
}

.nav-menu :deep(.el-menu-item) {
    height: 46px;
    line-height: 46px;
    border-radius: 12px;
    margin: 0 2px;
    border-bottom: none !important;
    font-size: 15px;
    font-weight: 600;
    color: #334155;
    padding: 0 14px;
    transition: all 0.22s ease;
}

.nav-menu :deep(.el-menu-item:hover) {
    color: #0f766e !important;
    background: rgba(13, 148, 136, 0.1) !important;
}

.nav-menu :deep(.el-menu-item.is-active) {
    color: #0f766e !important;
    background: rgba(13, 148, 136, 0.13) !important;
    box-shadow: inset 0 0 0 1px rgba(13, 148, 136, 0.18);
}

.nav-item {
    display: inline-flex !important;
    align-items: center;
    gap: 6px;
}

.logo {
    display: flex;
    align-items: center;
    margin-right: 12px;
    padding-right: 14px;
    cursor: pointer;
    border-right: 1px dashed rgba(51, 65, 85, 0.22);
}

.logo-image {
    width: 132px;
    height: 46px;
}

.logo-copy {
    margin-left: 4px;
    text-align: left;
}

.logo-title {
    font-family: "Avenir Next", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif;
    font-size: 15px;
    font-weight: 700;
    color: #0f172a;
    line-height: 1.1;
}

.logo-subtitle {
    margin-top: 3px;
    font-size: 11px;
    color: #475569;
}

.flex-grow {
    flex-grow: 1;
}

.btn-menu {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-left: 10px;
}

.nav-btn {
    height: 34px;
    min-width: 74px;
    font-size: 14px;
    font-weight: 600;
}

.nav-btn-primary {
    box-shadow: 0 8px 16px rgba(15, 118, 110, 0.25);
}

.nav-btn-ghost {
    border-color: rgba(51, 65, 85, 0.25);
    color: #0f172a;
}

.notice-badge {
    margin-left: 12px;
    margin-right: 10px;
    display: inline-flex;
    align-items: center;
}

.notice-btn {
    width: 38px;
    height: 38px;
    border: none;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.92);
    color: #0f172a;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.notice-btn:hover {
    color: #0f766e;
    background: #ecfeff;
}

.notice-item {
    width: 160px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.user-entry {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    border-radius: 14px;
    padding: 4px 8px 4px 4px;
    border: none;
    background: rgba(255, 255, 255, 0.92);
    cursor: pointer;
    transition: all 0.22s ease;
}

.user-entry:hover {
    background: rgba(236, 254, 255, 0.95);
    box-shadow: 0 8px 18px rgba(15, 118, 110, 0.14);
}

.user-avatar {
    background: linear-gradient(120deg, #0f766e 0%, #0891b2 100%);
    border: none;
    color: #ffffff;
    font-weight: 700;
}

.user-name {
    font-size: 14px;
    font-weight: 600;
    color: #1e293b;
    max-width: 128px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.user-caret {
    font-size: 14px;
    color: #64748b;
    transition: color 0.2s ease, transform 0.2s ease;
}

.user-entry:hover .user-caret {
    color: #0f766e;
    transform: translateY(1px);
}

.mobile-topbar {
    min-height: 62px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 2px 4px;
}

.mobile-logo-btn {
    border: none;
    background: transparent;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
}

.mobile-logo-image {
    width: 84px;
    height: 34px;
}

.mobile-logo-text {
    color: #0f172a;
    font-size: 16px;
    font-weight: 700;
}

.mobile-actions {
    display: inline-flex;
    align-items: center;
    gap: 8px;
}

.mobile-auth-btn {
    font-size: 14px;
    font-weight: 600;
    color: #0f766e;
}

.mobile-menu-btn {
    width: 38px;
    height: 38px;
    border-radius: 12px;
    border: 1px solid rgba(51, 65, 85, 0.2);
    background: rgba(255, 255, 255, 0.9);
    color: #0f172a;
    font-size: 22px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.mobile-user-entry {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
}

.mobile-notice {
    margin: 0;
}

:deep(.mobile-nav-drawer .el-drawer__body) {
    padding: 0;
}

.mobile-drawer-content {
    min-height: 100%;
    display: flex;
    flex-direction: column;
}

.mobile-drawer-head {
    padding: 16px 16px 10px;
    border-bottom: 1px solid rgba(148, 163, 184, 0.2);
}

.mobile-drawer-brand {
    display: flex;
    align-items: center;
    gap: 10px;
}

.mobile-drawer-logo {
    width: 88px;
    height: 36px;
}

.mobile-drawer-title {
    margin: 0;
    color: #0f172a;
    font-size: 16px;
    font-weight: 700;
}

.mobile-drawer-subtitle {
    margin: 2px 0 0;
    color: #64748b;
    font-size: 12px;
}

.mobile-drawer-menu {
    border-right: none !important;
    padding: 10px 8px 0;
}

.mobile-drawer-menu :deep(.el-menu-item) {
    border-radius: 10px;
    margin: 4px 0;
    font-size: 15px;
    font-weight: 600;
    color: #334155;
}

.mobile-drawer-menu :deep(.el-menu-item.is-active) {
    color: #0f766e !important;
    background: rgba(13, 148, 136, 0.1);
}

.mobile-drawer-footer {
    margin-top: auto;
    padding: 12px 16px 18px;
    border-top: 1px solid rgba(148, 163, 184, 0.2);
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.drawer-auth-btn {
    width: 100%;
}

.drawer-link-btn {
    width: 100%;
    justify-content: flex-start;
    margin: 0;
    color: #1e293b;
    font-weight: 600;
}

.drawer-link-btn.danger {
    color: #dc2626;
}

.auth-modal {
    overflow: hidden;
    border-radius: 18px;
}

.auth-modal-hero {
    padding: 18px 20px 16px;
    text-align: left;
    color: #ecf7ff;
    background:
      radial-gradient(circle at 8% 12%, rgba(125, 211, 252, 0.26), rgba(125, 211, 252, 0) 40%),
      linear-gradient(135deg, #0d5372 0%, #0d7a76 100%);
}

.auth-modal-kicker {
    margin: 0;
    font-size: 11px;
    letter-spacing: 0.14em;
    font-weight: 700;
    color: #bfe8ff;
}

.auth-modal-hero h3 {
    margin: 8px 0 6px;
    color: #f8fcff;
    font-size: 24px;
    line-height: 1.2;
}

.auth-modal-hero p {
    margin: 0;
    color: #daefff;
    font-size: 13px;
}

.auth-modal-body {
    padding: 20px 20px 18px;
    text-align: left;
    background: linear-gradient(180deg, rgba(252, 255, 255, 0.98), rgba(245, 251, 255, 0.96));
}

.auth-modal-form {
    width: 100%;
}

.auth-input {
    width: 100%;
}

.auth-modal-form :deep(.el-input__wrapper) {
    border-radius: 10px;
}

.auth-submit {
    width: 100%;
    height: 40px;
    border-radius: 10px;
    font-weight: 700;
    background: linear-gradient(90deg, #0f766e 0%, #0c5f74 100%);
    border: 0;
    box-shadow: 0 10px 18px rgba(12, 95, 116, 0.2);
}

.demo-auto-login {
    margin: 2px 0 14px;
    text-align: left;
}

.demo-auto-login a {
    float: right;
    color: #0f766e;
}

.forget-links {
    display: flex;
    justify-content: space-between;
}

.register-password {
    width: 100%;
}

.demo-register-tip {
    text-align: left;
}

.demo-register-tip-low {
    color: #ed4014;
}

.demo-register-tip-medium {
    color: #ff9900;
}

.demo-register-tip-strong {
    color: #19be6b;
}

.demo-register-tip-title {
    font-size: 14px;
}

.demo-register-tip-desc {
    white-space: initial;
    font-size: 13px;
    margin-top: 6px;
}

.auth-modal-switch {
    margin: 12px 0 0;
    text-align: center;
    color: #5f7590;
    font-size: 13px;
}

.auth-modal-switch a {
    color: #0f766e;
    font-weight: 600;
}

@media (max-width: 991px) {
    .nav-inner {
        padding: 5px 8px;
    }
}
</style>

<style lang="less">
.auth-modal-shell {
    margin-top: 74px;
    border-radius: 18px;
    overflow: hidden;
    border: 1px solid rgba(134, 172, 205, 0.36);
    box-shadow: 0 24px 52px rgba(21, 46, 74, 0.24);
    background: #ffffff;
}

.auth-modal-shell .el-dialog__header {
    display: none;
}

.auth-modal-shell .el-dialog__body {
    padding: 0;
}

.avatar-dropdown-popper {
    border: none !important;
    border-radius: 14px !important;
    padding: 8px !important;
    background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%) !important;
    box-shadow: 0 18px 42px rgba(15, 23, 42, 0.14), 0 3px 12px rgba(15, 23, 42, 0.08) !important;
}

.avatar-dropdown-popper .el-dropdown-menu {
    border: none !important;
    box-shadow: none !important;
    background: transparent !important;
    padding: 0 !important;
}

.avatar-dropdown-popper .el-dropdown-menu__item {
    min-width: 148px;
    height: 38px;
    line-height: 38px;
    border-radius: 10px;
    margin: 2px 0;
    padding: 0 12px;
    font-size: 14px;
    font-weight: 600;
    color: #334155;
    transition: all 0.2s ease;
}

.avatar-dropdown-popper .el-dropdown-menu__item:focus,
.avatar-dropdown-popper .el-dropdown-menu__item:not(.is-disabled):hover {
    color: #0f766e;
    background: rgba(13, 148, 136, 0.14);
}

.avatar-dropdown-popper .el-dropdown-menu__item--divided {
    margin-top: 8px;
}

.avatar-dropdown-popper .el-dropdown-menu__item--divided:before {
    left: 4px;
    right: 4px;
    background: rgba(148, 163, 184, 0.28);
}

.avatar-dropdown-popper .avatar-dropdown-item-danger {
    color: #dc2626;
}

.avatar-dropdown-popper .avatar-dropdown-item-danger:focus,
.avatar-dropdown-popper .avatar-dropdown-item-danger:not(.is-disabled):hover {
    color: #b91c1c;
    background: rgba(220, 38, 38, 0.14);
}
</style>
